import { Component } from '@angular/core';
import { format } from 'date-fns';
import { map } from 'rxjs';
import { DashboardsService } from 'src/app/modules/app/dashboards/dashboards.service';
import { projectDeadline } from 'src/app/modules/app/_reports/interfaces';

@Component({
  selector: 'app-dashboard-deadlines-card',
  templateUrl: './dashboard-deadlines-card.component.html',
  styleUrls: ['./dashboard-deadlines-card.component.scss'],
})
export class DashboardDeadlinesCardComponent {
  constructor(private _dashboardServ: DashboardsService) {
    this.GetDeadlines();
  }

  private _records: any[] = [];
  public get records(): any[] {
    return this._records;
  }
  public set records(v: any[]) {
    this._records = v;
  }

  GetDeadlines() {
    this._dashboardServ
      .GetDeadlines()
      .pipe(
        map((deadlines) => {
          deadlines.forEach((x: any) => {
            x.dueDate = format(new Date(x.dueDate), 'MMM do, yyyy');
          });

          return deadlines.filter((x: any) => x.remaining != '0');
        })
      )
      .subscribe({
        next: (res) => {
          this.records = res;
        },
      });
  }
}
